
export class StoreAccessoryRequestList{
    pageSize: number;
    pageNumber: number;
    
}

export class StoreAccessoryRequestCreate{
    index: number;
    name: string ;
    
}

export class StoreAccessoryRequestUpdate{
    index: number;
    name: string ;
    
}

export class StoreAccessoryRequestPublished{
    id: number;
    published : boolean ;
    
}

export class StoreAccessoryRequestSearch{
    name: string;
    pageNumber: number;
    pageSize: number;
    published: boolean;
    sortBy: string;
    
}